import type { ConstraintsSummaryLocale } from "@/locales/fr/constraints-summary";

const constraintsSummaryLocale: ConstraintsSummaryLocale = {
  constraintsSummary: {
    productionConstraints: "Production Constraints",
    definitive: "Definitive deactivation",
    temporary: "Temporary deactivation",
    links: "Deactivation by links",
    planning: "Planning",
    adjusting: "Modulations adjusting",
    manage: "Manage constraints",
    nothing: "No constraints",
  },
};

export default constraintsSummaryLocale;
